import ImagesPressLogosGoldBlueSpiritoryJpg from '@/public/images/press/logos/gold-blue/spiritory.jpg';
import ImagesPressLogosGoldBlueSpiritoryLogoJpg from '@/public/images/press/logos/gold-blue/spiritoryLogo.jpg';
import ImagesPressLogosGoldBlueSpiritoryLogoPng from '@/public/images/press/logos/gold-blue/spiritoryLogo.png';
import ImagesPressLogosGoldBlueSpiritoryLogoSvg from '@/public/images/press/logos/gold-blue/spiritoryLogo.svg';
import ImagesPressLogosGoldBlueSpiritoryPng from '@/public/images/press/logos/gold-blue/spiritory.png';
import ImagesPressLogosGoldBlueSpiritorySvg from '@/public/images/press/logos/gold-blue/spiritory.svg';

export {
  ImagesPressLogosGoldBlueSpiritoryJpg,
  ImagesPressLogosGoldBlueSpiritoryLogoJpg,
  ImagesPressLogosGoldBlueSpiritoryLogoPng,
  ImagesPressLogosGoldBlueSpiritoryLogoSvg,
  ImagesPressLogosGoldBlueSpiritoryPng,
  ImagesPressLogosGoldBlueSpiritorySvg,
};
